import { api } from '@/api/api-client.config.ts';
import { QuestionType } from '@/@types/api.types.ts';
import { useMutation } from '@tanstack/react-query';

interface CreateQuestionProps {
  pickemId: number;
  question: QuestionType;
}

const createQuestion = ({ pickemId, question }: CreateQuestionProps) =>
  api.post(`/admin/pickem-questions/${pickemId}`, question);

export const useCreateQuestionMutation = () => {
  return useMutation({
    mutationKey: ['createQuestion'],
    mutationFn: createQuestion,
  });
};
